import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem
} from '@/components/ui/dropdown-menu';
import { Globe, ArrowRight } from 'lucide-react';
import { COLORS } from './landingData';

export function Navbar({ lang, setLang, t }) {
  const navigate = useNavigate();

  return (
    <nav
      style={{
        position: 'sticky', top: 0, zIndex: 50,
        backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
        background: 'rgba(249,248,246,0.85)',
        borderBottom: `1px solid ${COLORS.border}`,
        padding: '0 24px',
      }}
      data-testid="landing-navbar"
    >
      <div className="landing-nav-inner" style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} data-testid="nav-logo">
          <img src="/logo-final-e.svg" alt="PharmX" style={{ height: 34, width: 'auto', objectFit: 'contain' }} />
        </div>
        <div className="landing-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
          <a href="#features" style={{ fontSize: 14, fontWeight: 600, color: COLORS.text, textDecoration: 'none', opacity: 0.85 }} className="nav-desktop-only">{lang === 'en' ? 'Features' : lang === 'ru' ? 'Возможности' : 'Имконотхо'}</a>
          <a href="#features" style={{ fontSize: 14, fontWeight: 600, color: COLORS.text, textDecoration: 'none', opacity: 0.85 }} className="nav-desktop-only">{lang === 'en' ? 'Solutions' : lang === 'ru' ? 'Решения' : 'Хизматрасонӣ'}</a>
          <a href="#pricing" style={{ fontSize: 14, fontWeight: 600, color: COLORS.text, textDecoration: 'none', opacity: 0.85 }} className="nav-desktop-only">{lang === 'en' ? 'Pricing' : lang === 'ru' ? 'Цены' : 'Нархҳо'}</a>
        </div>
        <div className="landing-nav-actions" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                style={{
                  background: 'transparent', border: `1px solid ${COLORS.border}`, borderRadius: 8,
                  padding: '6px 12px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 6, color: COLORS.text,
                }}
                data-testid="lang-switcher"
              >
                <Globe style={{ width: 14, height: 14 }} />
                {lang.toUpperCase()}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => setLang('en')} data-testid="lang-en">English</DropdownMenuItem>
              <DropdownMenuItem onClick={() => setLang('ru')} data-testid="lang-ru">Русский</DropdownMenuItem>
              <DropdownMenuItem onClick={() => setLang('tj')} data-testid="lang-tj">Тоҷикӣ</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/login')}
            className="nav-desktop-only"
            style={{ borderColor: COLORS.primary, color: COLORS.primary, fontWeight: 600 }}
            data-testid="nav-login-btn"
          >
            {t.nav.login}
          </Button>
          <Button
            size="sm"
            onClick={() => navigate('/login')}
            style={{ background: COLORS.primary, color: '#fff', fontWeight: 600 }}
            data-testid="nav-getstarted-btn"
          >
            {t.nav.getStarted} <ArrowRight style={{ width: 14, height: 14, marginLeft: 4 }} />
          </Button>
        </div>
      </div>
    </nav>
  );
}
